<div class="flex items-center cursor-pointer {{ extraClass }}" (click)="toggleCheckbox(item?.value)">
  <input
    type="checkbox"
    class="form-checkbox mr-sm rounded-xs text-info border-gray-300 focus:outline-none focus:ring-transparent focus:shadow-none {{
      extraCheckboxClass
    }}"
    style="box-shadow: none !important"
    [ngStyle]="{ width: size + 'px', height: size + 'px' }"
    [checked]="item ? formControl.value?.includes(item.value) : formControl.value"
    [disabled]="disabled"
  />
  <div class="text-sm leading-sm text-txt {{ extraLabelClass }}" [ngClass]="{ '!text-txt-disabled': disabled }">
    {{ item?.label ?? label }}
  </div>
</div>
